import * as React from 'react'
import { connect } from 'react-redux'

import { AutoSuggest } from 'components/Select'
import Style from 'components/Style'
import { Tag, Tags } from 'components/Tags'

import { City } from '../../data/models/funnelOrder/cities'
import { destinationEnum } from '../../data/models/funnelOrder/destination'
import {
  filterDestination,
  getMaxExcludedCities,
} from '../../data/models/funnelOrder/excludedCities'
import {
  getExcludeCitiesThemeAPIName,
  Theme,
  ThemeTypes,
} from '../../data/models/funnelOrder/theme'
import { getSiteCountryICC2, SiteCountry } from '../../data/models/locale'
import { getClient } from '../../data/openapi'
import { AppState } from '../../data/state'
import AutoCityExcludes from './AutoCityExcludes'
import { placeholder, searchPromptText } from './options'

interface FlyExcludedCitiesProps {
  theme: Theme
  country: SiteCountry
  excludedCities: City[]
  destination: destinationEnum
  max?: number
  solid?: boolean
  setExcludedCities(value: City[]): void
}

export interface ExcludeCitiesOptions {
  value: number
  label: string
  direction?: string
}

interface FlyExcludedCitiesState {
  themeCities: ExcludeCitiesOptions[]
}

class FlyExcludedCities extends React.Component<
  FlyExcludedCitiesProps,
  FlyExcludedCitiesState
> {
  constructor(props: FlyExcludedCitiesProps) {
    super(props)
    this.state = {
      themeCities: [],
    }
  }

  public componentDidMount() {
    const data = {
      theme: getExcludeCitiesThemeAPIName(this.props.theme),
      type: ThemeTypes.fly,
      site_country: getSiteCountryICC2(this.props.country),
    }
    getClient()
      .then(client => client.apis.bookings.bookings_theme_cities(data))
      .then(response => response.body)
      .then(cities => {
        this.setState({
          themeCities: cities.map((x: any) => ({
            value: x.id,
            label: x.name,
            direction: x.direction,
          })),
        })
      })
  }

  public render() {
    const { destination, excludedCities, theme, country } = this.props
    const max = this.getMax()

    const filtered = filterDestination(
      excludedCities,
      theme,
      destination || destinationEnum.allOfEurope,
      max,
    )

    return (
      <>
        {excludedCities.length >= max ? null : (
          <Style margin={[[0, 0, 20, 0]]}>
            <AutoSuggest
              options={this.getCities()}
              onChange={this.addTag}
              placeholder={placeholder[country]}
              searchPromptText={searchPromptText[country]}
            />
          </Style>
        )}

        <Tags solid={this.props.solid}>
          <AutoCityExcludes />
          {filtered.map((value, i) => (
            <Tag
              key={i}
              text={value.name}
              onDelete={() => this.deleteTag(value.id)}
            />
          ))}
          {excludedCities.map((value, i) => {
            if (!filtered.includes(value)) {
              return (
                <Tag
                  key={i}
                  text={value.name}
                  strikeThrough
                  onDelete={() => this.deleteTag(value.id)}
                />
              )
            }
          })}
        </Tags>
      </>
    )
  }

  private getCities = () => {
    return Promise.resolve(this.state.themeCities)
  }

  private addTag = (value: ExcludeCitiesOptions) => {
    if (value !== undefined) {
      const max = this.getMax()
      const cityValue: City = {
        id: value.value,
        name: value.label,
        direction: value.direction,
      }
      const excludedCities = [...this.props.excludedCities, cityValue].slice(
        0,
        max,
      )

      this.props.setExcludedCities(excludedCities)
    }
  }

  private getMax = () => {
    return (
      this.props.max ||
      getMaxExcludedCities(this.props.theme, this.props.destination)
    )
  }

  private deleteTag = (id: number) => {
    const excludedCities = this.props.excludedCities.filter(
      city => city.id !== id,
    )
    this.props.setExcludedCities(excludedCities)
  }
}

export default connect((state: AppState) => ({
  theme: state.funnelOrder.theme,
  country: state.locale.country,
}))(FlyExcludedCities)
